import React, {Component} from 'react';
import PropTypes from 'prop-types';

class CheckIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="16px"
          height="12px"
          viewBox="0 0 16 12"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon
              id="check-icon"
              points="9.32421875 15.3671875 18.1914062 6.5 19.3242188 7.671875 9.32421875 17.671875 4.67578125 13.0234375 5.84765625 11.8515625"
            ></polygon>
          </defs>
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-848.000000, -2114.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 753.000000)">
                <g id="row" transform="translate(0.000000, 1317.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-check-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#check-icon"></use>
                      </mask>
                      <use id="check" fill="currentColor" xlinkHref="#check-icon"></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

CheckIcon.propTypes = {
  className: PropTypes.string,
};

export default CheckIcon;
